import { Box, Card, CardHeader, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Tooltip } from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import usePlayers from "hooks/usePlayers";
import _ from "lodash";

const PlayersComponent = () => {
  const { data, isValidating } = usePlayers({ id: "" });
  return (
    <Card sx={{ m: 5 }}>
      <CardHeader title={"PLAYER"} />
      <PerfectScrollbar>
        <Box sx={{ minWidth: 800 }}>
          {isValidating || data == undefined ? (
            <Box style={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress size="10rem" sx={{ m: 3 }} />
            </Box>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Operator</TableCell>
                  <TableCell>Username</TableCell>
                  <TableCell sortDirection="desc">
                    <Tooltip enterDelay={300} title="Sort">
                      <TableSortLabel active direction="desc">
                        Created
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {_.isEmpty(data) == false &&
                  data?.items.map((deposit) => (
                    <TableRow hover key={deposit.id}>
                      <TableCell>{deposit.operatorId}</TableCell>
                      <TableCell>{deposit.userName}</TableCell>
                      <TableCell>{deposit.created.toString()}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          )}
        </Box>
      </PerfectScrollbar>
    </Card>
  );
};

export default PlayersComponent;
